var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkSimple = function SvgIconLinkSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.242 2.257c-1.459 0-2.858.58-3.89 1.61L9.7 6.522a1 1 0 1 0 1.414 1.414l2.654-2.653a3.501 3.501 0 1 1 4.95 4.951l-2.652 2.654a1 1 0 1 0 1.414 1.414l2.653-2.653a5.501 5.501 0 0 0-3.89-9.391m-.357 5.848a1 1 0 0 1 .001 1.414L9.53 15.885a1 1 0 1 1-1.415-1.413l6.356-6.366a1 1 0 0 1 1.414-.001m-7.95 1.594a1 1 0 0 1 0 1.414l-2.653 2.654a3.501 3.501 0 1 0 4.952 4.95l2.653-2.652a1 1 0 1 1 1.414 1.414l-2.653 2.653a5.5 5.5 0 0 1-9.391-3.89c0-1.459.58-2.858 1.611-3.89L6.521 9.7a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconLinkSimple;